export default function Canvas_Text_Color() {
  return (
    <div>
      <h1>Canvas_Text_Color Component</h1>
    </div>
  );
}
